import { c as _c } from "react/compiler-runtime";
import { classNames, SpaceBetween, TextBody, Truncate } from "@opensea/ui-kit";
export function ExpandedSearchRecentQueryResult(t0) {
  const $ = _c(7);
  const {
    item,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames("h-8 w-full items-center", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== item.data.query) {
    t2 = <Truncate><TextBody size="md">{item.data.query}</TextBody></Truncate>;
    $[2] = item.data.query;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <SpaceBetween className={t1}>{t2}</SpaceBetween>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}